import api from "@/config/apiConfig"

class FiscalConfigController {
  async index() {
    const response = await api.get("/fiscal-configs");
    return response.data;
  }

  async create(req) {
    const response = await api.post("/fiscal-configs", req);
    return response.data;
  }

  async update(req) {
    const response = await api.put(`/fiscal-configs/${req.id}`, req);
    return response.data;
  }

  async delete(id) {
    const response = await api.delete(`/fiscal-configs/${id}`);
    return response.data;
  }
}

export default new FiscalConfigController();
